import React from 'react'

const TableDarkStyle = {
  table: {
    style: {
      color: '#ffffff',
      backgroundColor: '#transparent',
    },
  },
  header: {
    style: {
      fontSize: '30px',
      color: 'white',
      backgroundColor: 'rgba(0, 0, 0, 0.24)',
      minHeight: '56px',
      paddingLeft: '16px',
      paddingRight: '8px',
    },
  },
  head: {
    style: {
      color: 'white',
      fontSize: '14px',
      fontWeight: 500,
    },
  },
  headRow: {
    style: {
      backgroundColor: 'transparent',
      minHeight: '52px',
      borderBottomWidth: '1px',
      borderBottomColor: 'transparent',
      borderBottomStyle: 'solid',
    },
    denseStyle: {
      minHeight: '32px',
    },
  },
  contextMenu: {
    style: {
      backgroundColor: 'black',
      fontSize: '18px',
      fontWeight: 400,
      color: 'black',
      paddingLeft: '16px',
      paddingRight: '8px',
      transform: 'translate3d(0, -100%, 0)',
      transitionDuration: '125ms',
      transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
      willChange: 'transform',
    },
    activeStyle: {
      transform: 'translate3d(0, 0, 0)',
    },
  },
  pagination: {
    style: {
      color: 'white',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: 'rgba(0,0,0,.085)',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: 'rgba(0,0,0,.085)',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: 'px',
      cursor: 'pointer',
      transition: '0.4s',
      color: 'white',
      fill: 'white',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#5f5f5f',
        fill: '#5f5f5f',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: 'white',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: 'white',
      },
    },
  },

  rows: {
    style: {
      fontSize: '13px',
      fontWeight: 400,
      color: 'white',
      backgroundColor: 'transparent',
      minHeight: '48px',
      '&:not(:last-of-type)': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderBottomColor: '#3a3a3a',
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        borderTopColor: '#3a3a3a',
      },
    },
    denseStyle: {
      minHeight: '32px',
    },
    stripedStyle: {
      color: 'white',
      backgroundColor: 'rgba(0,0,0,.085)',
    },
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
}

export default TableDarkStyle
